module.exports = __webpack_public_path__ + "static/media/linkedin.a3063068.svg";